module.exports = __webpack_public_path__ + "static/img/card0.963aae9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/card0.jpg
// module id = T1j2
// module chunks = 0